import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
//import VueCompositionAPI from '@vue/composition-api';
import VueOnlinePlugin from 'vue-navigator-online';
import '@fortawesome/fontawesome-free/css/all.css'
import es from 'vuetify/lib/locale/es'

Vue.use(Vuetify);

//Vue.use(VueCompositionAPI);
Vue.use(VueOnlinePlugin);
//configurar lenguaje a español
Vue.component('my-component', {
  methods: {
    changeLocale () {
      this.$vuetify.lang.current = 'es'
    },
  },
})

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es',
  },
  
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#04846c',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#00C851',
        warning: '#FFC107',
        selection: '#D9E7FD',
        icons:'#666666'

      },
    },
  },
  icons: {
    iconfont: 'md',
  },
});
